module.exports = __webpack_public_path__ + "assets/montserrat-semibold.6e574ac1d7c8bba08cb5aa382c66944b.woff";